import 'twin.macro';
import 'styled-components/macro';
import { add } from 'date-fns';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { Input } from '../../../component-lib';
import { ButtonV2 } from '../../../component-lib/atoms/button-v2/ButtonV2';

interface SweetFormProps {
  isLoading?: boolean;
  onSubmit: (sweet: { title: string; expiresAt: string }) => void;
  onCancel: () => void;
}

interface SweetFormValues {
  sweet: {
    title: string;
    expiresAt: string;
  };
}

const SweetForm = ({ isLoading, onSubmit, onCancel }: SweetFormProps) => {
  const sweetForm = useFormik<SweetFormValues>({
    initialValues: {
      sweet: {
        title: '',
        expiresAt: add(new Date(), { days: 1 }).toISOString().split('T')[0],
      },
    },
    validationSchema: Yup.object().shape({
      sweet: Yup.object().shape({
        title: Yup.string().required('Title is required'),
        expiresAt: Yup.string().required('Expiry date is required'),
      }),
    }),
    onSubmit: ({ sweet }) => {
      onSubmit({
        title: sweet.title,
        expiresAt: new Date(sweet.expiresAt).toISOString(),
      });
    },
  });

  return (
    <form onSubmit={sweetForm.handleSubmit}>
      <div tw="grid grid-cols-1 gap-2 mb-2">
        <Input
          label="Title"
          {...sweetForm.getFieldProps('sweet.title')}
          {...sweetForm.getFieldMeta('sweet.title')}
          disabled={isLoading}
        />
        <Input
          label="Expiry Date"
          type="date"
          {...sweetForm.getFieldProps('sweet.expiresAt')}
          {...sweetForm.getFieldMeta('sweet.expiresAt')}
          disabled={isLoading}
        />
      </div>
      <div tw="flex justify-end gap-2">
        <ButtonV2 onClick={onCancel}>Cancel</ButtonV2>
        <ButtonV2 variant="primary" type="submit" disabled={!sweetForm.isValid}>
          Add Sweet
        </ButtonV2>
      </div>
    </form>
  );
};

export default SweetForm;
